import { Component, OnDestroy, OnInit,} from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { AlertService } from 'src/app/services/alert.service';
import { EquipoGerencialService } from 'src/app/modulos/catalogos-proces/services/equipo.gerencial.service';
import { ModalService } from 'src/app/services/modal.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CatComunService } from '../../services/cat-comun.service';
import { IndicadoresService } from 'src/app/modulos/elementos-plan/services/indicadores.service';
import { ParticipanteElementoService } from 'src/app/modulos/elementos-plan/services/participante.elemento.service';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { DatePipe } from '@angular/common';
import { ProyectoService } from 'src/app/modulos/elementos-plan/services/proyecto.service';
import { UserService } from 'src/app/modulos/admin/services/user.service';
@Component({
  selector: 'app-equipo-gerencial',
  templateUrl: './equipo-gerencial.component.html',
  styleUrls: ['./equipo-gerencial.component.css']
})
export class EquipoGerencialComponent implements OnInit, OnDestroy {
  breadCrumbItems = [{ label: 'Admnistración procesos' }, { label: 'Gestión planes' }, { label: 'Participantes de los elementos', active: true }];
  public formUser!: UntypedFormGroup;
  public formEquipoGerencial!: FormGroup;
  public formRol!: FormGroup;
  public ipAddress!: string;
  public mostrarModal: boolean = false;
  public listaEquipoGerencialGuardar: any = [];
  public indiceEquipoGerencial: any = [];
  public indiceEquipoProyecto: any = [];
  public indiceResponsable: any = [];
  public indiceEquipoLineaAccion: any = [];
  public indiceEquipoPlanAccion: any = [];
  public conteo = 0
  public dataEquipoGerencial!: any;
  formSubmitted: boolean = false;
  public idRolParticipante = ConstantsCatalogosIdService.ID_COMUNES_TIPO_PARTICIPANTE;
  public idTipoParticipante = ConstantsCatalogosIdService.ID_COMUNES_TIPO_PARTICIPANTE;
  public idEquipoGerencial = ConstantsCatalogosIdService.ID_COMUNES_EQUIPO_GERENCIAL;
  public idEquipoProyecto = ConstantsCatalogosIdService.ID_COMUNES_EQUIPO_PROYECTOS;
  public idLiderProyecto = ConstantsCatalogosIdService.ID_COMUNES_LIDER_PROYECTO;
  public idParticipantes = ConstantsCatalogosIdService.ID_COMUNES_PARTICIPANTE; // revisar
  public idResponsable = ConstantsCatalogosIdService.ID_COMUNES_RESPONSABLE;  // id del responsable (titular)
  public idEquipoLineasAccion = ConstantsCatalogosIdService.ID_COMUNES_EQUIPO_LINEAS_ACCION //id del equipo de lineas de accion (lider)
  public idEquipoPlanesAccion = ConstantsCatalogosIdService.ID_COMUNES_EQUIPO_PLAN_ACCION // id equipo de planes de accion (lider)
  idSprEquipoEliminar: number = 0;
  showConfirm: boolean = false;

  public hoy = new Date();
  public pipe = new DatePipe('en-US');
  buffer!: any;
  currentUser!: any
  public nombres!: any;
  public apellidos!: any;
  public grado!: any;
  public estado1 = [];
  public estado2: string;
  dataUserSiipne: any;
  nameModal: string = "modalUsuariosSiipne";
  nameApp: string = "PARTICIPANTES DE LOS ELEMENTOS DE LA PLANIFICACIÓN";
  dataGerencialRoles: any;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  isDtInitialized: boolean = false;
  dtElement: DataTableDirective;
  listaEquipoGerencial = [];
 
  listaCat = [];
  nameEquipoGerencial = "PARTICIPANTES DE LOS ELEMENTOS DE LA PLANIFICACIÓN"
  private idSprAmbiente: number;
  public items = 1;




  readonly constant = ConstantsCatalogosIdService;

  constructor(
    private fb: FormBuilder,
    private equipoGerencialService: EquipoGerencialService,
    private userService: UserService,
    private ip: IpPublicService,
    private alert: AlertService,
    public modal: ModalService,
    private catComunService: CatComunService,
    private indicadorService: IndicadoresService,
    private participanteService: ParticipanteElementoService,


  ) {

    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.idSprAmbiente = this.currentUser.idSprAmbiente;

    this.formEquipoGerencial = this.fb.group({
      idSprEquipoGerencial: [''],
      idSprAmbiente: [''],
      idSprTipoParticipante: [''],
      gradoNombres: ['', Validators.required],
      cedula: ['', Validators.required],
      estado: ['', Validators.required],
      fechaInicio: ['', Validators.required],
      fechaFin: [''],
      cargoFuncion: ['', Validators.required],

    });

  }

  ngOnInit(): void {
    this.initApp()
    this.getIpPublic()

  }


  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  setForm() {
    this.formUser = this.fb.group({
      idSprUsuario: [0],
      cedula: ['', [Validators.required]],
    });


    this.formEquipoGerencial = this.fb.group({
      idSprEquipoGerencial: [''],
      idSprAmbiente: [''],
      idSprTipoParticipante: [''],
      gradoNombres: [''],
      cedula: [''],
      estado: ['', Validators.required],
      fechaInicio: ['', Validators.required],
      fechaFin: ['', Validators.required],
      cargoFuncion: ['', Validators.required],
    });


    this.formRol = this.fb.group({
      idSprTipoParticipante: [''],
      idSprAmbiente: [''],


    });
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });

    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }


  initApp() {


    this.setDataTable();
    this.setForm();
    this.getEquipoGerenciales();
    this.getDataCatalogosTipoParticipante();
    this.items = this.items++;

  }


  getEquipoGerenciales() {

    this.equipoGerencialService.list("?idSprAmbiente=" + this.idSprAmbiente).subscribe(
      {
        next: (lista) => {
          this.listaEquipoGerencial = lista;
          this.indiceEquipoGerencial = lista.filter(item => item.idSprTipoParticipante == this.idEquipoGerencial);
          this.indiceEquipoProyecto = lista.filter(item => item.idSprTipoParticipante == this.idEquipoProyecto || item.idSprTipoParticipante == this.idLiderProyecto);
          this.indiceResponsable = lista.filter(item => item.idSprTipoParticipante == this.idResponsable || item.idSprTipoParticipante == this.idResponsable)
          this.indiceEquipoLineaAccion = lista.filter(item => item.idSprTipoParticipante == this.idEquipoLineasAccion || item.idSprTipoParticipante == this.idEquipoLineasAccion)
          this.indiceEquipoPlanAccion = lista.filter(item => item.idSprTipoParticipante == this.idEquipoPlanesAccion || item.idSprTipoParticipante == this.idEquipoPlanesAccion)
        },
        error: (error) => {
        }

      }

    )

  }

  getDataCatalogosTipoParticipante() {
    this.catComunService.list("?spr_idSprComun=" + this.idTipoParticipante).subscribe(
      {
        next: (lista) => {
          this.listaCat = lista;
        },
        error: (error) => {
        }

      })

  }

  getNombreTipoParticipacion(id: number, tipoParticipantes: any[]) {
    return tipoParticipantes?.filter((participacion) => {
      return participacion.idSprComun === id;
    });
  }


  createParticipantes() {

  }

  createEquipoGerencial() {

    this.formEquipoGerencial.value.usuario = this.currentUser.idSprUsuario;
    this.formEquipoGerencial.value.ip = this.ipAddress;
    this.formEquipoGerencial.value.gradoNombres = `${this.grado} ${this.apellidos} ${this.nombres}`
    this.formEquipoGerencial.value.cedula = this.formUser.value.cedula
    this.formEquipoGerencial.value.delLog = "N";
    this.formEquipoGerencial.value.idSprAmbiente = this.currentUser.idSprAmbiente;
    this.formEquipoGerencial.value.ip = this.ipAddress;
    this.formSubmitted = true;
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split('T')[0];
    let FechaInicial = formattedDate;
    let fechaFinal = null;


    //Realizar el posteo
    if (this.formEquipoGerencial.value.idSprEquipoGerencial == null) {
      this.formEquipoGerencial.value.fechaInicio = FechaInicial
      this.formEquipoGerencial.value.fechaFin = fechaFinal
      // this.formEquipoGerencial.value.gradoNombres = this.formEquipoGerencial.value.gradoNombres

      this.equipoGerencialService.create(this.formEquipoGerencial.value)
        .subscribe(resp => {
          this.initApp()

          this.modal.closeId(this.nameModal)
          this.alert.createOk();
        }, (err) => {
          this.alert.createError();



        });
    } else {
      /**fecha fin: para que se guarde la fecha fin solo cuando el estado del participante sea inactivo */
      this.estado1 = this.formEquipoGerencial.value.estado;
      this.estado2 = this.estado1.toString();
      let fechaFinal1 = null;
      if (this.estado2 == '2') {
        fechaFinal1 = this.pipe.transform(this.hoy, 'yyyy-MM-dd')
      } else {
        fechaFinal1 = null;
      }
      this.formEquipoGerencial.value.fechaFin = fechaFinal1;
      /**fin fecha fin */
      this.equipoGerencialService.update(this.formEquipoGerencial.value)
        .subscribe(resp => {

          this.initApp()
          this.modal.closeId(this.nameModal)
          this.alert.updateOk();

        }, (err) => {
          this.alert.createError();
        });
    }


  }



  setearValores(data: any) {
    this.nombres = data.result.nombres;
    this.apellidos = data.result.apellidos;
    this.grado = data.result.grado;
  }

  validarCedula(cedula: string): boolean {

    if (cedula == null) {
      this.alert.warning('¡Atención!','Debe ingresar el número de cédula.'
      );
      return false;
    }

    if (cedula.length < 10) {
      this.alert.warning('¡Atención!','El número de cédula debe tener 10 digitos.'
      );
      return false;
    }
    return true;
  }


  buscaPersona() {

    if (this.validarCedula(this.formUser.value.cedula) || this.formUser.value.cedula == undefined) {
      try {
        if (!this.formUser.invalid) {
          this.userService
            .getPersonaSiipne(this.formUser.value.cedula)
            .subscribe((response) => {
              this.dataUserSiipne = response;
              if (!response) {
                this.alert.warning('¡Atención!','No existe usuario con esta cédula.')
                return;
              } 
                this.setearValores(this.dataUserSiipne);
            });
            return;
          } 
      }
      catch(e) {
        console.log('[INFO] Ocurrió un error: ', e.message );
      }
    }
  }

  openModal() {
    this.onResetForm();

    this.modal.open(this.nameModal);
  }


  onResetForm() {
    this.formSubmitted = false;
    this.formEquipoGerencial.reset();
    this.formUser.reset();
    this.nombres = "";
    this.grado = "";
    this.apellidos = "";
  }


  updateEquipoGerencial(obj: any) {

    this.modal.open(this.nameModal);


    this.formEquipoGerencial.patchValue({
      idSprAnio: obj.idSprAnio,
      idSprEquipoGerencial: obj.idSprEquipoGerencial,
      idSprTipoParticipante: obj.idSprTipoParticipante,
      idSprPlanInstitucional: obj.idSprPlanInstitucional,
      anio: obj.anio,
      fechaInicio: obj.fechaInicio,
      cargoFuncion: obj.cargoFuncion,
      //fechaFin:  fechaFinal1,
      // fechaFin: this.pipe.transform(this.hoy, 'yyyy-MM-dd'),
      fechaFin: obj.fechaFin,
      vigencia: obj.vigencia,
      estado: obj.estado
    });
    let datosDesarmados = obj.gradoNombres.split(" ")
    this.grado = datosDesarmados[0]
    this.nombres = `${datosDesarmados[1]} ${datosDesarmados[2]}`
    this.apellidos = `${datosDesarmados[3]} ${datosDesarmados[4]}`
    this.formUser.patchValue({

      cedula: obj.cedula


    })
  }
  closeModal() {
    this.modal.close()
  }


  deleteEquipoGerencial(id: number) {
    this.idSprEquipoEliminar= id;
    this.modal.open('deleteEquipoGeren');
  }

  verifyParticipante() {
    return this.participanteService.list(`?idSprEquipoGerencial=${this.idSprEquipoEliminar}&delLog=N`).toPromise();
  }
 
  async confirmDelete() {
    let confirmDelete = true;
    let dataVerifyRelacion: any = [];
    //##############  verificacion1 si existe datos relacionado ########################

    dataVerifyRelacion = await this.verifyParticipante();
    (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";
    //###################################################################################
   
    if (confirmDelete) {
      this.equipoGerencialService.update({
        "idSprEquipoGerencial": this.idSprEquipoEliminar,
        "usuario": this.currentUser.idSprUsuario,
        "delLog": "S",
        "ip": this.ipAddress
      })
        .subscribe(resp => {
          this.initApp();
          this.alert.deleteOk();
          this.modal.closeId("deleteEquipoGeren");

        }, (err) => {
          this.alert.deleteError();
          this.modal.close();
        });
    }
    else {
      this.alert.EliminarRegistro();
    }
  }
  showEliminar(id: number) {
    this.showConfirm = true;
    this.idSprEquipoEliminar = id;
  }

}
